import { Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import SimpleModal from "../../../components/common/SimpleModal";
import { setUpdateBot, toggleBotModal } from "../redux/botSlice";
import BotForm from "./form/BotForm";

const CountryTable = ({ data }) => {
  const dispatch = useDispatch();
  const { isOpenBotModal } = useSelector((state) => state.bot);

  const handleToggle = () => dispatch(toggleBotModal());
  const handleEdit = (data) => {
    dispatch(
      setUpdateBot({
        id: data.id,
        nickname: data.nickname,
        imageUrl: data?.imageUrl,
        username: data.username,
      })
    );
    handleToggle();
  };

  return (
    <>
      <SimpleModal
        show={isOpenBotModal}
        handleClose={handleToggle}
        title="ແກ້ໄຂຂໍ້ມູນບັອດ"
        size="md"
      >
        <BotForm handleClose={handleToggle} />
      </SimpleModal>
      <Table bordered responsive>
        <thead>
          <tr>
            <th className="text-center">
              <strong>#</strong>
            </th>
            <th className="text-center">
              <strong>ຊື່ຫຼິ້ນ</strong>
            </th>
            <th className="text-center">
              <strong>ຮູບ</strong>
            </th>
            <th className="text-center">
              <strong>ແກ້ໄຂ</strong>
            </th>
          </tr>
        </thead>
        <tbody>
          {data?.map((d, i) => {
            return (
              <tr key={d.id}>
                <td className="text-center">
                  <strong>{i + 1}</strong>
                </td>
                <td className="text-center">{d.nickname}</td>
                <td className="text-center">
                  <img
                    width={60}
                    src={d?.profileImage}
                    alt="ຶ"
                    className="img-thumbnail"
                  />
                </td>
                <td className="text-center">
                  <div
                    className="btn btn-primary shadow btn-xs sharp me-1"
                    onClick={() => handleEdit(d)}
                  >
                    <i className="fas fa-pencil-alt"></i>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
};

export default CountryTable;
